import Icon from "../../icons";
import { Dispatch, FC, SetStateAction } from "react";

interface Props {
  isExpanded: boolean;
  setIsExpanded: Dispatch<SetStateAction<boolean>>;
  small?: boolean;
}

interface BoxProps {
  small?: boolean;
  children: React.ReactNode;
  onClick?: () => void;
}

const ChevronCircleBox: FC<BoxProps> = ({ small, children, onClick }) => (
  <div
    onClick={onClick}
    className={`flex items-center justify-center rounded-full bg-grey hover:cursor-pointer hover:bg-greyBorder transition-colors ease-in-out ${
      small ? "h-5 w-5" : "h-6 w-6"
    }`}
  >
    {children}
  </div>
);

export const ChevronCircleButton = ({ isExpanded, setIsExpanded, small = false }: Props) => {
  const iconName = isExpanded ? "chevronUpIcon" : "chevronDownIcon";
  const iconSize = small ? "xxsmall" : "xsmall";

  return (
    <ChevronCircleBox small={small} onClick={() => setIsExpanded(!isExpanded)}>
      <Icon name={iconName} size={iconSize} />
    </ChevronCircleBox>
  );
};
